//@flow
import { gql, graphql } from "react-apollo"
import type { OperationComponent } from "react-apollo"

export const GetKiosksQuery = gql`
  query GetKiosks($query: String!) {
    kiosks(searchQuery: $query) {
      friendlyName
      shortName
      id
      startsAt
      endsAt
    }
  }
`

type Kiosk = {
  friendlyName: string,
  id: string,
  startsAt: string,
  endsAt: string
}

type Response = {
  kiosks: Kiosk[]
}

export type InputProps = {
  searchName: string
}

const withKiosks: OperationComponent<
  Response,
  InputProps
> = graphql(GetKiosksQuery, {
  name: "kiosks",
  options: ({ searchName }) => ({ variables: { query: searchName } })
})

export default withKiosks



// WEBPACK FOOTER //
// ./src/Kiosks/queries/withKiosks.js